<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>银行卡</h4>
      <div @click="backClick"><i class="fa fa-reply"></i></div>
      <!-- <el-button  size='mini' type="text" style="" @click="backClick">返回</el-button> -->
    </div>
    <div style="margin:20px 0 20px 20px;">
      <span>银行卡</span>
      &nbsp;&nbsp;&nbsp;
      <!-- <el-button  size='mini' type="primary" @click="addBankClick">添加银行卡</el-button> -->
      <!-- <el-button  size='mini' type="primary" style="" @click="backClick">返回</el-button> -->
    </div>
    <div class="bankBox">
      <p class="bank">{{topData.ext2}}</p>
      <p class="bankcard">卡号：{{bankAccount}}</p>
      <p class="yiBang" v-if="bankAccount !=''">已绑定</p>
      <p class="yiBang" v-if="bankAccount ==''">未绑定</p>
      <p class="yiBang2" v-if="bankAccount !=''" @click="jieBangClick">解绑</p>
      <p class="yiBang2" v-if="bankAccount ==''" @click="addBankClick">绑定</p>
    </div>

    <!-- 添加银行卡 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="bankMark"
    @close="reset('bankFrom')"
    width="900px"
    center>
      <span>
         <el-form
          :model="bankFrom"
          :rules = rules
          :validate-on-rule-change = "false"
          ref="bankFrom"
          class="demo-form-inline"
          label-width="140px" size="mini">
          <div style="height:100px;background:#f5f5f5;overflow: hidden;">
            <span style="color:red;display: block;margin:2px 0 0 10px;">
              <p>提示：</p>
              <p>1.为了顺利提现，开户银行填写请具体到支行，如：中信银行北京百子湾支行</p>
              <p>2.如果不清楚开户行支行信息可拨打银行客户电话咨询</p>
            </span>
          </div>
        <div class="addinpBox" style="margin-left:18%;">
          <el-form-item label="持卡人:" prop="cardholder" style="margin-top:20px;">
            <el-input  placeholder=""  maxlength=""  v-model.trim="bankFrom.cardholder" style="width:300px;"></el-input>
          </el-form-item>
          <el-form-item label="开户银行:" prop="openingBank" style="margin-top:20px;">
             <!-- <el-select v-model="bankFrom.openingBank" placeholder="请选择" style="width:200px;">
                  <el-option
                    v-for="(item,index) in openingBankOptions"
                    :key="index"
                    :label="item.showName"
                    :value="item.itemNo">
                  </el-option>
                </el-select> -->
              <el-input  placeholder=""  maxlength="50"  v-model.trim="bankFrom.openingBank" style="width:300px;"></el-input>
          </el-form-item>
          <el-form-item label="银行卡号:" prop="bankAccount" style="margin-top:20px;">
            <el-input   placeholder="" v-number-input.float="0" maxlength=""  v-model.trim="bankFrom.bankAccount" style="width:300px;"></el-input>
          </el-form-item>
           <el-form-item label="手机号:" prop="receivePhone" style="margin-top:20px;">
             <span>{{bankFrom.receivePhone}}</span>
          </el-form-item>
          <el-form-item label="验证码:" prop="code" style="margin-top:20px;">
            <el-input  placeholder="" v-number-input.float="0" maxlength="" auto-complete="new-password" v-model.trim="bankFrom.code" style="width:190px;"></el-input>
            &nbsp;
            <el-button  size='mini' v-if="isShowGetCode"  class="identiCode" type="primary" @click="codeClick">获取验证码</el-button>
              <span v-else class="identiCode cancel-pointer"
                >{{ countdown }}s后可重试</span
              >
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'  @click="setUpSubmit('bankFrom')"  :loading='SubmitLoading'>确定</el-button>
        <el-button @click="setUpClose('bankFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
    <!-- 解绑银行卡 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="jieBangbankMark"
    @close="reset2"
    width="500px"
    center>
      <span>
         <el-form
          :model="jieBangbankFrom"
          :rules = rules
          :validate-on-rule-change = "false"
          ref="jieBangbankFrom"
          class="demo-form-inline"
          label-width="140px" size="mini">
        <div class="addinpBox" >
          <el-form-item label="持卡人:"  style="margin-top:20px;">
            <span>{{topData.cardholder}}</span>
          </el-form-item>
           <el-form-item label="开户银行:" style="margin-top:20px;">
            <span>{{topData.ext2}}</span>
          </el-form-item>
           <el-form-item label="银行账户:"  style="margin-top:20px;">
            <span>{{topData.bankAccount}}</span>
          </el-form-item>
           <el-form-item label="手机号:" style="margin-top:20px;">
             <span>{{topData.receivePhone}}</span>
          </el-form-item>
          <el-form-item label="验证码:"  style="margin-top:20px;">
            <el-input  placeholder="" v-number-input.float="0" maxlength=""  v-model.trim="jieBangbankFrom.code" style="width:92px;"></el-input>
            &nbsp;
            <el-button  size='mini' v-if="isShowGetCode2"   type="primary" @click="codeClick2">获取验证码</el-button>
              <span v-else class="identiCode"
                >{{ countdown2 }}s后可重试</span
              >
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'  @click="jieBangSubmit"  :loading='jieBangLoading'>解绑</el-button>
        <el-button @click="jieBangClose()" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getPayDetailByPC,
  sendSmsCode, // 手机验证码
  getDictionaryList, // 开户行
  addBankData, // 添加银行卡
  updateBankDataUntie // 解绑
} from '@/api/consignment'
import DonMessage from '@/utils/message'
// eslint-disable-next-line no-unused-vars
import { getBtn } from '@/utils/getButton'
// eslint-disable-next-line no-unused-vars
import store from '@/store'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP003B001', '00DP003B002', '00DP003B003',
        '00DP003B004', '00DP003B005', '00DP003B006'],
      activeName: 'first',
      editableTabs: [],
      editableTabsValue: 'first',
      title: '',
      h: '500px',
      total: 0,
      bankMark: false,
      bankFrom: {
        id: '',
        cardholder: '', // 持卡人
        openingBank: '', // 开户银行
        bankAccount: '', // 银行账户
        receivePhone: '', // 手机号
        code: ''// 验证码
      },
      rules: {
        cardholder: [
          { required: true, message: '持卡人不能为空', trigger: 'blur' }
        ],
        openingBank: [
          { required: true, message: '开户行不能为空', trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: '银行账户不能为空', trigger: 'blur' }
        ],
        receivePhone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      },
      SubmitLoading: false,
      openingBankOptions: [],
      bankAccount: '', // 卡号
      // 解绑
      jieBangbankMark: false,
      topData: {},
      jieBangbankFrom: {
        code: ''
      },
      jieBangLoading: false,
      isShowGetCode: true,
      countdown: 60,
      isShowGetCode2: true,
      countdown2: 60,
      timer: '',
      timer2: ''
    }
  },
  mounted () {
    // let h = this.$refs.searchBox.offsetHeight
    // let pH = document.documentElement.clientHeight
    // this.h = (pH - h - 150) + 'px'
  },
  created () {
    this.getDictionaryList()
    this.bankFrom.receivePhone = localStorage.getItem('receivePhone2')
    this.bankFrom.id = localStorage.getItem('accountId2')
    this.bankAccount = localStorage.getItem('bankAccount2')
    // console.log(this.bankFrom.id)
    this.getTopData()
    // this.btnFlg = getBtn(this.btnIdArr, '/waybillManagement')
  },
  methods: {
    getTopData () {
      getPayDetailByPC({
        accountType: 4 // 账户类型1-货主 2-司机 3-车队  4-车队长
      }).then(res => {
        this.bankAccount = res.bankAccount
        this.topData = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 字典
    getDictionaryList () {
      getDictionaryList({
        groupNo: 'openbank'
      }).then(res => {
        this.openingBankOptions = res.openbank
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 点击添加
    addBankClick () {
      this.bankMark = true
      this.title = '添加银行卡'
    },
    // 获取验证码
    codeClick () {
      this.countDown()
      this.isShowGetCode = false
      sendSmsCode({
        account: this.bankFrom.receivePhone
      }).then(res => {

      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    countDown () {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
        }
      }, 1000)
    },
    // 获取验证码
    codeClick2 () {
      this.countDown2()
      this.isShowGetCode2 = false
      sendSmsCode({
        account: this.bankFrom.receivePhone
      }).then(res => {

      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    countDown2 () {
      const self = this
      this.timer2 = setInterval(() => {
        self.countdown2--
        if (self.countdown2 === 0) {
          clearInterval(self.timer2)
          self.countdown2 = 60
          self.isShowGetCode2 = true
        }
      }, 1000)
    },
    // 确定
    setUpSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubmitLoading = true
          addBankData(this.bankFrom).then(res => {
            this.SubmitLoading = false
            DonMessage.success('添加成功')
            this.bankMark = false
            this.isShowGetCode = true
            this.countdown = 60
            clearInterval(this.timer)
            this.getTopData()
          }).catch(err => {
            this.SubmitLoading = false
            DonMessage.error(err.message)
          })
          // alert('submit!');
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    setUpClose (formName) {
      this.bankMark = false
      this.$refs[formName].resetFields()
      this.isShowGetCode = true
      this.countdown = 60
      clearInterval(this.timer)
    },
    // 解绑
    jieBangClick () {
      this.jieBangbankMark = true
      this.title = '解绑提现银行卡'
    },
    jieBangSubmit () {
      if (this.jieBangbankFrom.code == '') {
        DonMessage.error('验证码不能为空！')
      } else {
        this.jieBangLoading = true
        updateBankDataUntie({
          id: this.topData.id,
          code: this.jieBangbankFrom.code
        }).then(res => {
          this.jieBangLoading = false
          DonMessage.success('解绑成功')
          this.jieBangbankMark = false
          this.isShowGetCode2 = true
          this.countdown2 = 60
          clearInterval(this.timer2)
          this.getTopData()
        }).catch(err => {
          this.jieBangLoading = false
          DonMessage.error(err.message)
        })
      }
    },
    // 解绑取消
    jieBangClose () {
      this.jieBangbankMark = false
      this.jieBangbankFrom.code = ''
      this.isShowGetCode2 = true
      this.countdown2 = 60
      clearInterval(this.timer2)
    },
    reset (formName) {
      var _this = this
      _this.$refs[formName].resetFields()
    },
    reset2 () {
      this.jieBangbankFrom.code = ''
    },
    // 返回
    backClick () {
      this.$router.push('/captainPay/ziJin')
    }
  }
}
</script>
<style scoped lang='less'>
.bankBox{
  width: 280px;
  height: 180px;
  border: solid 1px #ccc;
  border-radius: 10px;
  margin:0 0 0 20px;
  position: relative;
  .bank{
    text-align: center;
    margin-top: 50px;
  }
  .bankcard{
    text-align: center;
    // margin-top: 70px;
  }
  .yiBang{
    position: absolute;
    bottom: 0;
    left: 15px;
    color: green;
  }
  .yiBang2{
    position: absolute;
    bottom: 0;
    right: 15px;
    color: #409EFF;
    cursor: pointer;
  }
}
</style>
